import React from 'react';

import PrivateContainer from '@/features/PrivatePageContainer/PrivatePageContainer';

import { CommunityPortalContextProvider } from '@/contexts/CommunityPortalContext';
import { GoogleCalendarProvider } from '@/contexts/GoogleCalendarProvider';
import { MagicReachContextProvider } from '@/contexts/MagicReachContext';

import PortalLayout from './components/PortalLayout';

const PortalPageLayout = ({ children }) => {
  return (
    <PrivateContainer>
      <GoogleCalendarProvider>
        <CommunityPortalContextProvider>
          <MagicReachContextProvider>
            <PortalLayout>{children}</PortalLayout>
          </MagicReachContextProvider>
        </CommunityPortalContextProvider>
      </GoogleCalendarProvider>
    </PrivateContainer>
  );
};

export default PortalPageLayout;
